// src/components/controlRondas/NfcTutorial.jsx
import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/NfcTutorial.scss';

const NfcTutorial = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  
  const steps = [
    {
      title: "Bienvenido a la gestión de NFC",
      content: "Los tags NFC permiten verificar puntos de control de manera precisa simplemente acercando el dispositivo móvil. Sigue los pasos para aprender a registrar y usar etiquetas NFC.",
      image: "step1.svg" // Podrías usar una imagen explicativa en cada paso
    },
    {
      title: "Registra etiquetas NFC",
      content: "Registra tus etiquetas NFC en esta sección. Cada etiqueta debe tener un nombre único y una ubicación. Necesitarás un dispositivo Android con Chrome o Edge para leer las etiquetas.",
      image: "step2.svg"
    },
    {
      title: "Asigna etiquetas a puntos de control",
      content: "Una vez registradas, asigna las etiquetas a los puntos de control. Puedes hacerlo desde la pantalla de creación o edición de puntos de control.",
      image: "step3.svg"
    },
    {
      title: "Verificación con la app móvil",
      content: "Los vigilantes podrán verificar los puntos de control mediante la app móvil simplemente acercando su dispositivo a la etiqueta NFC instalada en el punto.",
      image: "step4.svg"
    }
  ];
  
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };
  
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  
  return (
    <div className="nfc-tutorial-overlay">
      <div className="nfc-tutorial">
        <div className="tutorial-header">
          <h3 className="title">Tutorial NFC</h3>
          <button 
            onClick={onClose}
            className="btn-close"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="tutorial-content">
          <div className="step-image">
            {/* Imagen ilustrativa del paso actual */}
            <div className="image-placeholder">
              {steps[currentStep].image}
            </div>
          </div>
          
          <div className="step-content">
            <h3 className="step-title">{steps[currentStep].title}</h3>
            <p className="step-description">{steps[currentStep].content}</p>
          </div>
          
          <div className="step-indicators">
            {steps.map((_, index) => (
              <div 
                key={index} 
                className={`step-dot ${index === currentStep ? 'active' : ''}`}
              />
            ))}
          </div>
        </div>
        
        <div className="tutorial-actions">
          {currentStep > 0 && (
            <button
              onClick={handlePrevious}
              className="btn-previous"
            >
              <ChevronLeft size={20} />
              Anterior
            </button>
          )}
          
          <button
            onClick={handleNext}
            className="btn-next"
          >
            {currentStep < steps.length - 1 ? (
              <>
                Siguiente
                <ChevronRight size={20} />
              </>
            ) : 'Finalizar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NfcTutorial;